import apiClient from './client';

/**
 * Request to skip activity session
 * @param {number} sessionId - ID of the activity session
 */
export const createSkipRequest = async (sessionId) => {
  const response = await apiClient.post(
    `/activity_sessions/${sessionId}/skip_session_requests`
  );
  return response.data;
};
